enum userGroup {
    researcher = 1,
    officer = 2,
    president = 3,
    reviewer = 4,
    committee = 5,
    vicePresident = 6,
    secretary = 7,
    systemAdmin = 8,
}
export default userGroup
